import React, { useState, useEffect } from "react";
import styles from "./About.module.scss";
import Aos from "aos";
import "aos/dist/aos.css";
import luka from "../../images/luka.webp"; // Koristite WebP format
import nemanja from "../../images/nemanja.webp";
import jelica from "../../images/jelica.webp";
import alisa from "../../images/alisa.webp";

const trainers = [
  {
    name: "Luka Lončarević",
    bio: "Osnivač ESCAPE DANCE STUDIJA\nPlesni instruktor",
    longbio: "Svoju prvu plesnu iskustva stekao sam još kao dete trenirajući i takmičeći se u latino–američkim i standardnim plesovima. Danas imam 30 godina i više od 20 godina bavim se plesom. Karijeru sam gradio nižući uspehe kroz mnoga takmičenja – između ostalih i u formacijskom plesu u kome sam sa svojim timom ostvario jedan od nezapamćenih uspeha za našu zemlju.\n" +
      "\n" +
      "Imao sam sreće da svoje iskustvo obogatim plešući u Japanu, nakon čega sam odlučio da nastavim da prenosim svoje znanje radeći kao trener pre svega sa najmlađim članovima, ali i sa odraslima. Pored plesa, kao moje prve ljubavi, veliku strast gajim i prema muzici, zbog čega učestvujem u festivalima, koncertima, osmišljavam muzičke spotove i druge događaje, plešem i glumim u istim i trudim se da svoje dve ljubavi spojim u jednu, pretvarajući sve u jednu veliku igru.",
    img: `${luka}`
  },
  {
    name: "Nemanja Nikolić",
    bio: "Osnivač ESCAPE DANCE STUDIJA\nPlesni instruktor",
    longbio: "Imam 24 godine, a moj plesni put počeo je sa svega 4 godine. Tokom 20 godina karijere stekao sam bogato iskustvo kao dugogodišnji takmičar i državni prvak u latino i formacijskom plesu. Kao trener, radio sam sa različitim uzrasnim grupama, uključujući decu, odrasle, pa čak i penzionere, prenoseći im svoju ljubav prema plesu. Svoje plesne sposobnosti prikazivao sam u TV emisijama, spotovima, koncertima i nastupima. Za mene, ples nije samo aktivnost, već je suštinski deo mog života i predstavlja mnogo više od igre.",
    img: `${nemanja}`
  },
  {
    name: "Jelica Vasić",
    bio: "Plesni instruktor / saradnik",
    longbio: "Plesnu karijeru sam započela sa svojih sedam godina plešući show dance u plesnom klubu Casina. Nakon toga počela sam da treniram i takmičim se u latino-američkim, standardnim, kao i društvenim plesovima. Iako sam master ekonomije, do danas nisam napustila svoju ljubav prema plesu zbog čega se trudim da prenosim svoje znanje i veštine, što je i razlog zbog čega već dugi niz godina radim kao plesni instruktor.",
    img: `${jelica}`
  }
];

const About = () => {
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  const toggleExpand = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  return (
    <section className={styles.about} id="onama" role="region" aria-label="O nama">
      <h2 data-aos="fade-up">Ko smo mi?</h2>
      <p data-aos="fade-up">Escape Dance Studio je mesto gde se strast prema plesu pretvara u umetnost.</p>

      <div className={styles.trainers}>
        {trainers.map((trainer, index) => (
          <div data-aos="fade-up" key={index} className={styles.trainer}>
            <img src={trainer.img} alt={trainer.name} loading="lazy" /> {/* Dodajte loading="lazy" za lenjo učitavanje */}
            <h3>{trainer.name}</h3>
            <p>{trainer.bio}</p>

            <button className={styles.readMoreBtn} onClick={() => toggleExpand(index)}>
              {expanded === index ? "Pročitaj manje" : "Pročitaj više"}
            </button>

            <div className={`${styles.longBio} ${expanded === index ? styles.expanded : ""}`}>
              <p>{trainer.longbio}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default About;